import {
  Badge,
  Box,
  Flex,
  Menu,
  MenuButton,
  MenuDivider,
  MenuItem,
  MenuList,
  Text,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { MdKeyboardArrowDown, MdAdd } from "react-icons/md";
import { fetchController } from "../../utils/FetchController/fetchController";
import { getHostDomain } from "../../utils/utils";
import CreateTeamModal from "../Settings/Manage-Teams/CreateTeamModal";

const PERSONAL_ID = "personal";

const TeamSwitcher = () => {
  const [teams, setTeams] = useState([]);
  const [activeTeamId, setActiveTeamId] = useState(
    localStorage.getItem("activeTeamId") || PERSONAL_ID
  );
  const [isCreateOpen, setIsCreateOpen] = useState(false);

  const loadTeams = async () => {
    try {
      const res = await fetchController(
        getHostDomain() + "/api/v1/team/list",
        "GET"
      );
      setTeams(res?.data || []);
    } catch {
      // silently skip — team feature may not be used by this account
    }
  };

  useEffect(() => {
    loadTeams();
  }, []);

  const activeLabel =
    activeTeamId === PERSONAL_ID
      ? "Personal"
      : teams.find((t) => t.id === activeTeamId)?.name || "Personal";

  const handleSelect = (id) => {
    if (id === PERSONAL_ID) {
      localStorage.removeItem("activeTeamId");
    } else {
      localStorage.setItem("activeTeamId", id);
    }
    setActiveTeamId(id);
    window.location.reload();
  };

  const handleTeamCreated = (newTeam) => {
    setIsCreateOpen(false);
    loadTeams();
    if (newTeam?.id) {
      localStorage.setItem("activeTeamId", newTeam.id);
      setActiveTeamId(newTeam.id);
      window.location.reload();
    }
  };

  return (
    <>
      <Box px={2} w="100%">
        <Menu>
          <MenuButton w="100%">
            <Flex
              align="center"
              justify="space-between"
              bg="gray.100"
              _dark={{ bg: "gray.700" }}
              px={3}
              py={2}
              borderRadius="md"
              cursor="pointer"
              fontSize="sm"
            >
              <Flex align="center" gap={2}>
                <Badge
                  colorScheme={activeTeamId === PERSONAL_ID ? "gray" : "blue"}
                  fontSize="0.6em"
                >
                  {activeTeamId === PERSONAL_ID ? "Personal" : "Team"}
                </Badge>
                <Text fontWeight="medium" noOfLines={1}>
                  {activeLabel}
                </Text>
              </Flex>
              <MdKeyboardArrowDown />
            </Flex>
          </MenuButton>
          <MenuList zIndex={200}>
            <MenuItem
              fontSize="sm"
              fontWeight={activeTeamId === PERSONAL_ID ? "bold" : "normal"}
              onClick={() => handleSelect(PERSONAL_ID)}
            >
              Personal
            </MenuItem>
            {teams.map((t) => (
              <MenuItem
                key={t.id}
                fontSize="sm"
                fontWeight={activeTeamId === t.id ? "bold" : "normal"}
                onClick={() => handleSelect(t.id)}
              >
                {t.name}
              </MenuItem>
            ))}
            <MenuDivider />
            <MenuItem
              fontSize="sm"
              icon={<MdAdd />}
              onClick={() => setIsCreateOpen(true)}
            >
              Create new team
            </MenuItem>
          </MenuList>
        </Menu>
      </Box>
      <CreateTeamModal
        isOpen={isCreateOpen}
        onClose={() => setIsCreateOpen(false)}
        onCreated={handleTeamCreated}
      />
    </>
  );
};

export default TeamSwitcher;
